import { cx } from '@flowus/common/cx';
import { MindMapContext } from '@flowus/mind-map';
import type { FC } from 'react';
import { useContext } from 'react';
import { getIllegalText } from 'src/common/const';
import { BlockDefaultIcon } from 'src/components/block-default-icon';
import { IconTrigger } from 'src/components/icon-trigger';
import { useObservableBlock } from 'src/services/rxjs-redux/hook';
import { RichText } from '../uikit/editable/rich-text';
import { BackgroundContainer } from './background-container';
import type { PageProps } from './types';
import { useCoverImageUrl } from './use-cover-image-url';
import { useFetchFirstTextBlock } from './use-fetch-first-text-block';

export const SmallFillBackgroundCard: FC<PageProps> = (props) => {
  const { id, ownerBlockId, illegal, showIcon, showCover, desc } = props;
  const firstTextBlockSegments = useFetchFirstTextBlock(props.id, !desc);
  const isInMinMap = !!useContext(MindMapContext);
  const hasCover = !!useCoverImageUrl(id) && showCover;
  const fillBgColor = !!useObservableBlock(id, (block) => block?.backgroundColor) && !hasCover;
  return (
    <BackgroundContainer
      blockId={id}
      fillBgColor={fillBgColor}
      showCover={showCover}
      className={cx('flex justify-between items-center w-full h-[90px] animate-hover pl-3', {
        'min-w-[300px] max-w-[800px]': isInMinMap,
        'border-l border-t border-b': showCover,
        border: !showCover,
      })}
      onClick={props.onClick}
    >
      <div className="flex items-center overflow-hidden">
        {showIcon && (
          <IconTrigger
            trigger={!ownerBlockId} // feat:引用page不支持更改图标
            iconSize={40}
            className="mr-2"
            tooltipClassName="flex-shrink-0"
            hasOverlay={Boolean(ownerBlockId)}
            blockId={id}
            offset={[100, 0]}
            defaultIcon={<BlockDefaultIcon uuid={id} />}
          />
        )}
        <div>
          <div
            className={cx('text-t1 h-6 overflow-hidden break-words line-clamp-1', {
              'text-white': hasCover || fillBgColor,
            })}
          >
            {illegal ? getIllegalText() : props.title}
          </div>
          {!illegal && desc && (
            <div
              className={cx(
                'text-t4 text-grey3 h-4 overflow-hidden pr-1 mt-1 break-words line-clamp-1',
                {
                  'text-white': hasCover || fillBgColor,
                }
              )}
              style={{
                color: props.descColor,
              }}
            >
              {desc}
            </div>
          )}
          {!illegal && !desc && firstTextBlockSegments && (
            <RichText
              className={cx('text-t4 text-grey3 h-4 overflow-hidden pr-1 mt-1 line-clamp-1', {
                'text-white': hasCover || fillBgColor,
              })}
              segments={firstTextBlockSegments}
            />
          )}
        </div>
      </div>
    </BackgroundContainer>
  );
};
